import React, { useContext, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, Card, Checkbox, Chip, CircularProgress, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputAdornment, MenuItem, Modal, Radio, RadioGroup, Select, Stack, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Add, ArrowBack } from '@mui/icons-material';
import { useForm, Controller, FormProvider, set, useFormContext } from 'react-hook-form';
import { isMobile } from 'react-device-detect';
import Swal from 'sweetalert2';

import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { Helpers } from '../../../services/Helpers';
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { NotificationDataContext } from './AddEditNotification';
import { CustomerService } from '../../Customer/Service';
// import { CouponServices } from './CouponServices';
import generateAlphanumeric from '../../../utils/generateAlphanumeric';
import isExpired from '../../../utils/checkCouponExpiry';

const NotificationForm = () => {
    const navigate = useNavigate();
    const { couponData } = useContext(NotificationDataContext);
    const { control, watch, handleSubmit, setValue, formState: { isDirty, errors, dirtyFields }, reset } = useFormContext({
        mode: 'onSubmit',
        defaultValues: couponData,
    })
    const startDate = watch('startDate');
    const endDate = watch('expireDate');

    const [isLoadingCustomerList, setIsLoadingCustomerList] = useState(false);
    const [customerList, setCustomerList] = useState([]);

    // fetch customer list
    const fetchCustomerlist = async () => {
        setIsLoadingCustomerList(true)
        try {
            const customerListResponse = await CustomerService.unsortedCustomerList(gender);
            if (customerListResponse.success === 1) {
                setCustomerList(customerListResponse.data)
            }
        } catch (error) {

        } finally {
            setIsLoadingCustomerList(false);
        }
    }
    const gender = watch('gender');
    useEffect(() => {
        setValue('selectedCustomers', [])
        fetchCustomerlist();
    }, [gender])
    // Helper function to format customer name
    const getFullName = (profile) => {
        if (!profile) return '';
        return [profile.firstName, profile.middleName, profile.lastName]
            .filter(Boolean)
            .join(' ');
    };
    // const gender = watch('gender');

    return (
        <>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                        Select Gender <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box>
                    </Typography>
                    <Controller
                        name="gender"
                        control={control}
                        rules={{
                            // required: 'Select Gender',
                        }}
                        render={({ field, fieldState: { error } }) => (
                            <FormControl component="fieldset" fullWidth error={!!error} >
                                <RadioGroup
                                    {...field}
                                    row
                                    aria-label="gender"
                                    name="gender"
                                    sx={{ mt: 1 }}
                                >
                                    <FormControlLabel
                                        value="Male"
                                        control={<Radio size="small" />}
                                        label={
                                            <Typography sx={{ fontSize: '0.75rem' }}>
                                                Male
                                            </Typography>
                                        }
                                        sx={{ mr: 3 }}
                                    />
                                    <FormControlLabel
                                        value="Female"
                                        control={<Radio size="small" />}
                                        label={
                                            <Typography sx={{ fontSize: '0.75rem' }}>
                                                Female
                                            </Typography>
                                        }
                                        sx={{ mr: 3 }}
                                    />
                                    <FormControlLabel
                                        value=""
                                        control={<Radio size="small" />}
                                        label={
                                            <Typography sx={{ fontSize: '0.75rem' }}>
                                                All
                                            </Typography>
                                        }
                                    />
                                </RadioGroup>

                            </FormControl>
                        )}
                    />
                </Grid>
                {/* <Grid item xs={1} sx={{ display: { xs: 'none', md: 'block' } }} />
                <Grid item xs={12} sm={5.5}>
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Select Coupon Type <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                    <Controller
                        name="couponType"
                        control={control}
                        rules={{
                            required: 'Select Coupon Type',
                        }}
                        render={({ field, fieldState: { error } }) => (
                            <FormControl sx={{ minWidth: "100%" }} size="small">
                                <Select
                                    {...field}
                                    error={!!error}
                                    sx={{
                                        fontSize: '0.75rem',
                                    }}
                                >
                                    <MenuItem value={'fixed'} sx={{ textTransform: 'capitalize', fontSize: '0.75rem' }}>Fixed</MenuItem>
                                    <MenuItem value={'percentage'} sx={{ textTransform: 'capitalize', fontSize: '0.75rem' }}>Percentage</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    />
                </Grid> */}
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Select Customers<Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        {/* <Controller
                            name="selectedCustomers"
                            control={control}
                            defaultValue={[]}  // Keep default value as null when no selection
                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                <Autocomplete
                                    fullWidth
                                    disabled={isLoadingCustomerList}
                                    multiple // Enable multiple selection
                                    options={customerList || []}
                                    getOptionLabel={(option) => {
                                        if (!option) return '';
                                        const profile = option.profile || {};
                                        const fullName = getFullName(profile);
                                        return fullName ? `${fullName} (${option.mobileNumber || ''})` : '';
                                    }}
                                    value={value || []}
                                    onChange={(event, newValues) => {
                                        if (newValues && newValues.length > 0) {
                                            // Map the selected values to only include the IDs
                                            const selectedIds = newValues.map(item => ({ id: item.id }));
                                            onChange(selectedIds);
                                        } else {
                                            // If no customers selected, set value to null
                                            onChange([]);
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size='small'
                                            placeholder='Select customers'
                                            variant="outlined"
                                            error={!!error}
                                            InputProps={{
                                                ...params.InputProps,
                                                style: { fontSize: '0.75rem', color: '#000' },
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => {
                                        const profile = option.profile || {};
                                        const fullName = getFullName(profile);
                                        return (
                                            <MenuItem
                                                {...props}
                                                style={{
                                                    fontSize: '0.8rem',
                                                    padding: '8px 16px',
                                                    borderBottom: '1px solid #f0f0f0'
                                                }}
                                            >
                                                <Box style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <Box style={{ fontWeight: '600', color: '#3e3e3e' }}>
                                                        {fullName}
                                                        {option.isTester &&
                                                            <span style={{
                                                                marginLeft: '8px',
                                                                background: '#ffecb3',
                                                                padding: '1px 4px',
                                                                borderRadius: '4px',
                                                                fontSize: '0.65rem'
                                                            }}>
                                                                Tester
                                                            </span>
                                                        }
                                                        <span style={{ marginLeft: '8px', fontSize: '0.7rem', color: '#666' }}>
                                                            ({option.mobileNumber})
                                                        </span>
                                                    </Box>
                                                </Box>
                                            </MenuItem>
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        if (!option || !value) return false;
                                        return option.id === value.id;
                                    }}
                                    noOptionsText={<span style={{ fontSize: '0.75rem' }}>No customers found</span>}
                                    ListboxProps={{
                                        style: {
                                            maxHeight: '250px',
                                            fontSize: '0.8rem'
                                        }
                                    }}
                                    PaperProps={{
                                        style: {
                                            marginTop: '4px',
                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
                                        }
                                    }}
                                    // Add chip styling for selected items
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => {
                                            const profile = customerList.find(item => item.id === option.id)?.profile || {};
                                            const fullName = getFullName(profile);
                                            return (
                                                <Chip
                                                    label={fullName}
                                                    size="small"
                                                    {...getTagProps({ index })}
                                                    style={{
                                                        fontSize: '0.7rem',
                                                        height: '24px',
                                                        marginRight: '4px'
                                                    }}
                                                />
                                            );
                                        })
                                    }
                                />  
                                                                      
                            )}
                        /> */}
                        <Controller
                            name="selectedCustomers"
                            control={control}
                            defaultValue={[]}
                            rules={{
                                validate: (value) =>
                                    Array.isArray(value) && value.length > 0 || 'At least one customer must be selected',
                            }}
                            render={({ field: { onChange, value }, fieldState: { error } }) => {
                                const allCustomerIds = customerList.map(c => c.id);
                                const selectedIds = (value || []).map(c => c.id);

                                const isAllSelected = customerList.length > 0 && selectedIds.length === customerList.length;
                                const isIndeterminate = selectedIds.length > 0 && selectedIds.length < customerList.length;

                                // Inject special select-all option
                                const selectAllOption = {
                                    id: '__all__',
                                    profile: { firstName: 'Select All Customers' },
                                };

                                const optionsWithSelectAll = [selectAllOption, ...customerList];

                                const handleChange = (event, newValues) => {
                                    const hasSelectAll = newValues.some(val => val.id === '__all__');

                                    if (hasSelectAll) {
                                        if (isAllSelected) {
                                            onChange([]); // Unselect all
                                        } else {
                                            onChange(customerList.map(item => ({ id: item.id }))); // Select all
                                        }
                                    } else {
                                        onChange(newValues.map(item => ({ id: item.id })));
                                    }
                                };

                                return (
                                    <Autocomplete
                                        fullWidth
                                        multiple
                                        disableCloseOnSelect
                                        options={optionsWithSelectAll}
                                        value={value || []}
                                        loading={isLoadingCustomerList}
                                        onChange={handleChange}
                                        getOptionLabel={(option) => {
                                            if (option.id === '__all__') return 'Select All Customers';
                                            const profile = option.profile || {};
                                            return `${getFullName(profile)} (${option.mobileNumber || ''})`;
                                        }}
                                        isOptionEqualToValue={(option, val) => option.id === val.id}
                                        renderOption={(props, option, { selected }) => {
                                            if (option.id === '__all__') {
                                                return (
                                                    <MenuItem {...props}>
                                                        <Checkbox
                                                            checked={isAllSelected}
                                                            indeterminate={isIndeterminate}
                                                            size="small"
                                                            sx={{ mr: 1 }}
                                                        />
                                                        Select All Customers
                                                    </MenuItem>
                                                );
                                            }

                                            const profile = option.profile || {};
                                            const fullName = getFullName(profile);
                                            return (
                                                <MenuItem {...props}>
                                                    <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                                                    <Box>
                                                        <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                                            {fullName}
                                                            {option.isTester && (
                                                                <Box component="span" sx={{
                                                                    ml: 1,
                                                                    background: '#ffecb3',
                                                                    px: 0.5,
                                                                    borderRadius: '4px',
                                                                    fontSize: '0.65rem',
                                                                }}>
                                                                    Tester
                                                                </Box>
                                                            )}
                                                            <Box component="span" sx={{ ml: 1, fontSize: '0.7rem', color: '#666' }}>
                                                                ({option.mobileNumber})
                                                            </Box>
                                                        </Typography>
                                                    </Box>
                                                </MenuItem>
                                            );
                                        }}
                                        renderTags={(tagValue, getTagProps) => {
                                            const selectedIds = tagValue.map(c => c.id);
                                            const allSelected = customerList.length > 0 && selectedIds.length === customerList.length;

                                            // Show single tag if all customers selected
                                            if (allSelected) {
                                                return (
                                                    <Chip
                                                        label={`All Customers (${customerList.length})`}
                                                        size="small"
                                                        sx={{ fontSize: '0.7rem', height: '24px', mr: 0.5 }}
                                                    />
                                                );
                                            }

                                            // Show normal customer tags
                                            return tagValue.map((option, index) => {
                                                const profile = customerList.find(item => item.id === option.id)?.profile || {};
                                                const fullName = getFullName(profile);
                                                return (
                                                    <Chip
                                                        label={fullName}
                                                        size="small"
                                                        {...getTagProps({ index })}
                                                        sx={{
                                                            fontSize: '0.7rem',
                                                            height: '24px',
                                                            mr: 0.5
                                                        }}
                                                    />
                                                );
                                            });
                                        }}
                                        noOptionsText={<span style={{ fontSize: '0.75rem' }}>No customers found</span>}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                placeholder="Select customers"
                                                error={!!error}
                                                helperText={error?.message}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { fontSize: '0.75rem', color: '#000' },
                                                    endAdornment: (
                                                        <>
                                                            {isLoadingCustomerList && <CircularProgress size={16} />}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                );
                            }}
                        />

                        {isLoadingCustomerList && <CircularProgress />}
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Title <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                    <Controller
                        name="title"
                        control={control}
                        rules={{
                            required: 'Enter Notification Title',
                        }}
                        render={({ field, fieldState: { error } }) =>
                            <TextField
                                {...field}
                                fullWidth
                                size='small'
                                error={!!error}
                                helperText={error?.message}
                                InputProps={{
                                    style: { fontSize: '0.75rem' }
                                }}
                            />
                        }
                    />
                </Grid>

                {/* <Grid item xs={12} sm={5.5}>
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Start Date <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                    <Controller
                        control={control}
                        name="startDate"
                        // defaultValue={dayjs().format('YYYY-MM-DD')}
                        rules={{
                            required: 'Start Date is required',
                            validate: (value) => {
                                if (!value) return "This field is required";
                                const date = dayjs(value);
                                const today = dayjs().startOf('day');

                                if (!date.isValid()) return "Invalid date";
                                if (couponData.id>0 && !isExpired(couponData?.endDate)){
                                    return true;
                                }else if (date.isBefore(today)) return "Start date must be in the future";

                                return true;
                            }
                        }}
                        render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    {...restField}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            fontSize: '0.75rem'
                                        }
                                    }}
                                    value={value ? dayjs(value) : null}
                                    onChange={(newValue) => {
                                        onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                    }}
                                    format="DD-MM-YYYY"
                                    minDate={dayjs()}
                                    slotProps={{
                                        textField: {
                                            error: !!error,
                                            // helperText: error?.message,
                                            fullWidth: true,
                                            size: 'small',
                                            inputProps: {
                                                style: { fontSize: '.75rem' }
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        )}
                    />
                </Grid>
                <Grid item xs={1} sx={{ display: { xs: 'none', md: 'block' } }} />
                <Grid item xs={12} sm={5.5}>
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600,color:!startDate?'lightGray':'black' }}>End Date <Box component={'span'} sx={{ color: !startDate?'lightGray':'#d32f2f' }}>*</Box></Typography>
                    <Controller
                        control={control}
                        name="endDate"
                        // defaultValue={dayjs().add(1, 'day').format('YYYY-MM-DD')}
                        rules={{
                            required: 'End Date is required',
                            validate: (value) => {
                                if (!value) return "This field is required";
                                const date = dayjs(value);
                                const startDateValue = watch('startDate');
                                const startDate = dayjs(startDateValue);

                                if (!date.isValid()) return "Invalid date";
                                if (date.isBefore(startDate)) return "End date must be after start date";
                                // if(date.isSame(startDate)) return "End date must be after start date";

                                return true;
                            }
                        }}
                        render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    {...restField}
                                    disabled={!startDate}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            fontSize: '0.75rem'
                                        }
                                    }}
                                    value={value ? dayjs(value) : null}
                                    onChange={(newValue) => {
                                        onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                    }}
                                    format="DD-MM-YYYY"
                                    //after today and after startdate
                                    // minDate={watch('startDate') ? dayjs(watch('startDate')).add(1, 'day') : dayjs().add(1, 'day')}
                                    minDate={watch('startDate') ? dayjs(watch('startDate')) : dayjs()}
                                    slotProps={{
                                        textField: {
                                            error: !!error,
                                            // helperText: error?.message,
                                            fullWidth: true,
                                            size: 'small',
                                            inputProps: {
                                                style: { fontSize: '.75rem' }
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        )}
                    />
                </Grid> */}
                <Grid item xs={12} >
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Body <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                    <Controller
                        control={control}
                        name="body"
                        rules={{
                            required: 'Enter Notification Body',
                        }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                size='small'
                                error={!!error}
                                helperText={error?.message}
                                value={value}
                                onChange={onChange}
                                InputProps={{
                                    style: { fontSize: '0.65rem' }
                                }}
                            />
                        )}
                    />
                </Grid>

            </Grid>
        </>
    );
}

export default NotificationForm;

const formatValue = (value) => {
    if (typeof value !== 'string') {
        return value === 0 ? '0' : value?.toString() || '';
    }
    const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    return formatted === '' ? '' : formatted;
};